import { createContext, useState, useEffect } from "react";

const UserContext = createContext({
  user: null, // {auth, products, revalidate }
  userPiano: null,
  userPianoAccesses: [],
  isValidPianoUser: function () {},
  getPianoUser: function () {},
  deletePianoSession: function () {},
});

export function UserContextProvider(props) {
  /**
   * This function manage the changes on the user state
   */

  const [cookie, setCookie] = useState(null); // used for normal user cookie based
  const [userPianoState, setUserPiano] = useState(null); // used for piano login
  const [userPianoAccesses, setUserPianoAccesses] = useState([]);

  useEffect(() => {
    if (userPianoState !== null && window.tp && window.tp.api) {
      window.tp.api.callApi("/access/list", {}, function (response) {
        setUserPianoAccesses(response.data || []);
      });
    } else {
      setUserPianoAccesses([]);
    }
  }, [userPianoState]);

  /**
   * Return if logged user data
   * @returns Object || null
   */
  function getPianoUserHandler(user) {
    if (
      typeof window !== "undefined" &&
      window.tp &&
      window.tp.pianoId &&
      typeof window.tp.pianoId.getUser === "function"
    ) {
      setUserPiano(user || window.tp.pianoId.getUser());
    }
  }

  /**
   * Return if logged true || null
   * @returns Boolean
   */
  function getIsValidUser() {
    let isValid = false;
    if (
      typeof window !== "undefined" &&
      window.tp &&
      window.tp.pianoId &&
      typeof window.tp.pianoId.isUserValid === "function"
    ) {
      isValid = window.tp.pianoId.isUserValid();
    }
    return isValid;
  }

  /**
   * Logout Piano user session
   * @returns Boolean
   */
  async function deletePianoSessionHandler() {
    if (
      typeof window === "undefined" ||
      !window.tp ||
      !window.tp.pianoId ||
      typeof window.tp.pianoId.logout !== "function"
    ) {
      return false;
    }
    const isValid = await window.tp.pianoId.logout();
    setUserPiano(null);
    return isValid;
  }

  const context = {
    user: cookie,
    userPiano: userPianoState,
    userPianoAccesses: userPianoAccesses,
    getPianoUser: getPianoUserHandler,
    isValidPianoUser: getIsValidUser,
    deletePianoSession: deletePianoSessionHandler,
  };

  return (
    <UserContext.Provider value={context}>
      {props.children}
    </UserContext.Provider>
  );
}

export default UserContext;
